// World - Scene management and game world
import { Terrain } from './Terrain';
import { Assistant } from './Assistant';
import { HeartParticles } from './HeartParticles';
import { Rendering } from '../Rendering';
import type { TownState } from '../../game/townState';

export class World {
    public terrain: Terrain;
    public assistant: Assistant;
    public heart: HeartParticles;

    constructor() {
        this.terrain = new Terrain();
        this.assistant = new Assistant();
        this.heart = new HeartParticles();

        // Add heart to scene
        Rendering.getInstance().scene.add(this.heart.points);

        // Hide assistant initially? No, we might want to see them in background?
        // Actually for the "Void" look, we might want to hide everything else or just position camera high up.
        // Let's keep them present but maybe far away? 
        // With Isometric camera, we can just look at the heart which is at (0, 5, 0).
    }

    async updateFromState(_townState: TownState): Promise<void> {
        // Just update assistant if needed
    }

    update(delta: number): void {
        this.terrain.update(delta);
        this.assistant.update(delta);
        this.heart.update(delta / 1000); // Heart expects seconds? delta is ms usually?
        // HeartParticles.ts uses: time += delta * 2;
        // Game.ts calls world.update(this.time.delta) where delta is in seconds (usually? let's check Time.ts).
        // Actually Time.ts delta is usually seconds in Three.js apps, but let's verify. 
        // If it's rapid, it might be ms. 
        // Assuming seconds based on Three.js standard Clock.getDelta(). 
    }
}
